import SidebarButtonContainer from './SidebarButtonContainer';

export default SidebarButtonContainer;



// WEBPACK FOOTER //
// ./src/components/pages/User/Sidebar/SidebarButton/index.js